import { FlexColumn, FlexRow, StyledSearchBar } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import JobsFilters from '../JobsFilters';
import JobsSelectedFilters from '../JobsSelectedFilters';

type Props = {
  search?: string;
  onChangeSearch: (search: string) => void;
};
export function JobsCalendarFiltersBar({ search, onChangeSearch }: Readonly<Props>) {
  const { css, theme } = useStyles();

  return (
    <FlexColumn gap={theme.sizing.scale300}>
      <FlexRow
        classNames={css({ alignItems: 'center' })}
        gap={'4px'}
      >
        <FlexRow
          classNames={css({ flex: '1', alignItems: 'center' })}
          gap={'4px'}
        >
          <span className={css({ flexGrow: '0.5' })}>
            <StyledSearchBar
              name={'jobs-search'}
              value={search}
              onChange={onChangeSearch}
              clearable
              noMargin
            />
          </span>
          <JobsFilters
            disabledStatusFilter
            disabledDateFilter
          />
        </FlexRow>
      </FlexRow>
      <JobsSelectedFilters disabledStatusFilter />
    </FlexColumn>
  );
}
